(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  // Sections already on screen at load stay as they are, so nothing visible flickers.
  var viewportBottom = window.innerHeight;
  var sections = Array.prototype.filter.call(main.querySelectorAll('.shopify-section'), function (section) {
    return section.getBoundingClientRect().top > viewportBottom;
  });
  if (!sections.length) return;

  document.documentElement.classList.add('js-reveal');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  sections.forEach(function (section) {
    section.classList.add('reveal-on-scroll');
    observer.observe(section);
  });
})();
